import AuthService from '../../shared/services/AuthService';
import { CustomLoadingProgress } from '../../shared/components/CustomLoadingProgress';
import Grid from '@mui/material/Unstable_Grid2';
import { NoticeReceiver } from 'notifications/models/NoticeReceiver';
import { NotificationPanel } from './NotificationPanel';
import React from 'react';
import Typography from '@mui/material/Typography';
import { isEmpty } from 'lodash';
import useNotifications from '../../notifications/hooks/useNotifications';

export const ReceivedNotifications = (props: {
  notifications: NoticeReceiver[];
}) => {
  const notifications = props.notifications;
  const { loading } = useNotifications(AuthService.Userkey, true);

  return loading ? (
    <Grid style={{ textAlign: 'center' }}>
      <CustomLoadingProgress />
    </Grid>
  ) : isEmpty(notifications) ? (
    <Typography variant="body1" align="center" style={{ marginTop: '8px' }}>
      There are no notifications.
    </Typography>
  ) : (
    <>
      {notifications?.map((notification) => (
        <NotificationPanel
          key={notification.noticekey}
          notification={notification}
        />
      ))}
    </>
  );
};
